<fullscreen-page>
  <content-column>
    <div slot="content" class="p-2 flex-fill overflow-auto">
      <dx-toolbar>
        <dxi-item location="before"
                  widget="dxButton"
                  [options]="{ type: 'default', text: 'Neuen Workflow anlegen' | translate, onClick: createNewWorkflow }">

        </dxi-item>
        <dxi-item location="after">
          <np-help-button>
            <np-help-option text="Wiki"
                            icon="images/Wiki.svg"
                            link="https://knowledge.nextpim.de/grundlagen?utm_source=app.nextpim.de&utm_medium=affiliate&utm_campaign=wikilink#produktdaten"></np-help-option>
          </np-help-button>
        </dxi-item>
      </dx-toolbar>
      <dx-accordion [dataSource]="workflows"
                    itemTemplate="workflowItemTemplate"
                    [collapsible]="true"
                    [multiple]="false"
                    noDataText="{{ 'keine Workflows vorhanden' | translate }}"
                    [selectedIndex]="-1"
                    class="np-accordion">
        <div *dxTemplate="let workflow of 'title'">
          <div class="dx-accordion-item-title-caption d-flex align-items-center w-100">
            <div class="d-flex align-items-center gap-1 me-auto">
              @if (!workflow.editMode) {
              <span>{{ workflow.name }}</span>
              <dx-button class="btn-icon np-accordion-hoverable"
                         stylingMode="text"
                         type="default"
                         icon="add"
                         hint="{{ 'Workflowitem hizufügen' | translate }}"
                         (onClick)="addWorkflowItem($event, workflow)" />
              <dx-button class="btn-icon np-accordion-hoverable"
                         stylingMode="text"
                         type="default"
                         icon="copy"
                         hint="{{ 'Workflow kopieren' | translate }}"
                         (onClick)="copyWorkflow($event, workflow)" />
              <dx-button class="btn-icon np-accordion-hoverable"
                         stylingMode="text"
                         type="default"
                         icon="edit"
                         hint="{{ 'Workflow umbennen' | translate }}"
                         (onClick)="toggleWorkflowEditMode($event, workflow)" />
              }
              @else {
              <div class="np-field">
                <dx-text-box [(value)]="workflow.name"
                             [showClearButton]="true"
                             [readOnly]="false">
                </dx-text-box>
              </div>

              <dx-button class="btn-icon"
                         stylingMode="text"
                         type="default"
                         icon="check"
                         (onClick)="updateWorkflow($event, workflow)" />
              }
            </div>
            <div *ngIf="!workflow.editMode" class="justify-content-end">
              <dx-button class="btn-icon"
                         stylingMode="text"
                         type="default"
                         icon="trash"
                         hint="{{ 'Workflow löschen' | translate }}"
                         (onClick)="deleteWorkflow($event, workflow)" />
            </div>

          </div>

        </div>
        <div *dxTemplate="let workflow of 'workflowItemTemplate'">
          <workflow-items [(workflow)]="workflow">

          </workflow-items>
        </div>
      </dx-accordion>
      <dx-popup [(visible)]="popupExistingWorkflowplansVisible"
                contentTemplate="popupContent"
                [hideOnOutsideClick]="true"
                [showCloseButton]="true"
                [width]="400"
                [height]="400"
                [showTitle]="true"
                title="{{'Löschen nicht möglich' | translate}}">
        <div *dxTemplate="let data of 'popupContent'">
          <p>{{ 'Workflow kann nicht gelöscht werden, da bei folgenden Katalogen noch Workflowpläne für diesen Workflow existieren!' | translate}}</p>
          <ul>
            <li *ngFor="let link of linkList">
              <a [href]="link.url">{{ link.text }}</a>
            </li>
          </ul>
        </div>
      </dx-popup>
    </div>
  </content-column>
</fullscreen-page>
